<template>
  <LazyDrawer position="right" :is-open="basketTray" :hide-scroll="false">
    <template #header>
      <Stack tag="div" align="start" justify="end">
        <button
          @click="closeTray()"
          class="text-charcoal-default justify-self-end"
          data-test-id="closeCartTrayBtn"
          data-fs="closeCartTrayBtn"
        >
          <Icon name="plus-thick" filled class="text-charcoal-default rotate-45" :size="16" />
          <span class="sr-only">Close Cart Tray</span>
        </button>
      </Stack>

      <Stack
        align="end"
        gap="xs"
        justify="start"
        class="w-fit"
        data-test-id="cartTrayItemNumber"
        data-fs="cartTrayItemNumber"
      >
        <Heading tag="h3" size="xs" class="mt-xs whitespace-nowrap">Your basket</Heading>
        <Text
          v-if="cart?.line_items?.length"
          class="mt-xs"
          data-fs="cartTrayItemNumber"
          data-test-id="cartTrayItemNumber"
          >{{ cart?.line_items?.length }} items</Text
        >
      </Stack>
      <Banner
        variant="error"
        v-if="cart && isError"
        class="mt-sm"
        banner-test-id="basketTrayErrorMsg"
        data-fs="basketTrayError"
      >
        Unfortunately one or more items in your basket are not available for purchase from your selected branch. Please
        remove these items from your basket in order to proceed with your order
      </Banner>
      <Banner
        variant="warning"
        v-if="cart && merged"
        class="mt-xs"
        banner-test-id="basketTrayMergedMsg"
        data-fs="basketTrayMerged"
      >
        We've merged items from a previous visit into your current basket. Please ensure they are correct.
      </Banner>
    </template>

    <aside class="h-full max-h-screen flex flex-col justify-between" data-test-id="cartTrayOpen" data-fs="cartTrayOpen">
      <Basket v-if="cart" />
      <EmptyBasket v-else />
    </aside>
  </LazyDrawer>
</template>

<script setup lang="ts">
import { ROUTES } from "~/helpers/routes/routes";
import { useRoute } from "vue-router";

const route = useRoute();

const { setBasketTray, basketTray, branchSwitchTray, mergeWarning, basketTrayCanOpen } = useUIState();
const { cart, merged } = useCart();

const cartObject = ref(cart);

const isError = computed(() => {
  return cartObject.value?.line_items?.some((item) => item.availability_flag === 3 || item.error.length > 0);
});

const closeTray = () => {
  setBasketTray();
  merged.value = false;
};

watch([merged, branchSwitchTray, mergeWarning], ([mergedVal, branchTrayVal, mergeWarningVal]) => {
  if (mergeWarning.value === true || mergeWarning.value === null) {
    basketTrayCanOpen.value = false;
    return;
  }

  const canOpenTray =
    mergedVal && !branchTrayVal && !mergeWarningVal && basketTrayCanOpen.value && route.path !== ROUTES.CART;

  if (canOpenTray) {
    setBasketTray(true);
  }
});
</script>
